import { useQuery } from '@tanstack/react-query';
import workstationControlCenterService, {
  type WorkstationControlCenterQueryParams,
} from '../services/workstationControlCenter.service';

const unwrap = (res: { data?: { data?: unknown } }) => res.data?.data ?? res.data;

export function useWccSummary(params?: WorkstationControlCenterQueryParams, refetchInterval?: number) {
  return useQuery({
    queryKey: ['wcc', 'summary', params],
    queryFn: async () => unwrap(await workstationControlCenterService.getSummary(params)),
    refetchInterval,
  });
}

export function useWccStatusBoard(params?: WorkstationControlCenterQueryParams) {
  return useQuery({
    queryKey: ['wcc', 'status-board', params],
    queryFn: async () => unwrap(await workstationControlCenterService.getStatusBoard(params)),
  });
}

export function useWccCurrentWork(params?: WorkstationControlCenterQueryParams) {
  return useQuery({
    queryKey: ['wcc', 'current-work', params],
    queryFn: async () => unwrap(await workstationControlCenterService.getCurrentWork(params)),
  });
}

export function useWccQueues(params?: WorkstationControlCenterQueryParams) {
  return useQuery({
    queryKey: ['wcc', 'queues', params],
    queryFn: async () => unwrap(await workstationControlCenterService.getQueues(params)),
  });
}

export function useWccCapacity(params?: WorkstationControlCenterQueryParams) {
  return useQuery({
    queryKey: ['wcc', 'capacity', params],
    queryFn: async () => unwrap(await workstationControlCenterService.getCapacity(params)),
  });
}

export function useWccHours(params?: WorkstationControlCenterQueryParams) {
  return useQuery({
    queryKey: ['wcc', 'hours', params],
    queryFn: async () => unwrap(await workstationControlCenterService.getHours(params)),
  });
}

export function useWccFabrication(params?: WorkstationControlCenterQueryParams) {
  return useQuery({
    queryKey: ['wcc', 'fabrication', params],
    queryFn: async () => unwrap(await workstationControlCenterService.getFabricationUnits(params)),
  });
}

export function useWccMaterial(params?: WorkstationControlCenterQueryParams) {
  return useQuery({
    queryKey: ['wcc', 'material', params],
    queryFn: async () => unwrap(await workstationControlCenterService.getMaterialDependencies(params)),
  });
}

export function useWccInspection(params?: WorkstationControlCenterQueryParams) {
  return useQuery({
    queryKey: ['wcc', 'inspection', params],
    queryFn: async () => unwrap(await workstationControlCenterService.getInspectionDependencies(params)),
  });
}

export function useWccOutsource(params?: WorkstationControlCenterQueryParams) {
  return useQuery({
    queryKey: ['wcc', 'outsource', params],
    queryFn: async () => unwrap(await workstationControlCenterService.getOutsourceDependencies(params)),
  });
}

export function useWccBottlenecks(params?: WorkstationControlCenterQueryParams) {
  return useQuery({
    queryKey: ['wcc', 'bottlenecks', params],
    queryFn: async () => unwrap(await workstationControlCenterService.getBottlenecks(params)),
  });
}

export function useWccOperators(params?: WorkstationControlCenterQueryParams) {
  return useQuery({
    queryKey: ['wcc', 'operators', params],
    queryFn: async () => unwrap(await workstationControlCenterService.getOperators(params)),
  });
}

export function useWccMaintenance(params?: WorkstationControlCenterQueryParams) {
  return useQuery({
    queryKey: ['wcc', 'maintenance', params],
    queryFn: async () => unwrap(await workstationControlCenterService.getMaintenance(params)),
  });
}

export function useWccCapacityForecast(params?: WorkstationControlCenterQueryParams) {
  return useQuery({
    queryKey: ['wcc', 'capacity-forecast', params],
    queryFn: async () => unwrap(await workstationControlCenterService.getCapacityForecast(params)),
  });
}

export function useWccTimeline(params?: WorkstationControlCenterQueryParams) {
  return useQuery({
    queryKey: ['wcc', 'timeline', params],
    queryFn: async () => unwrap(await workstationControlCenterService.getTimeline(params)),
  });
}

export function useWccAlerts(params?: WorkstationControlCenterQueryParams, refetchInterval?: number) {
  return useQuery({
    queryKey: ['wcc', 'alerts', params],
    queryFn: async () => unwrap(await workstationControlCenterService.getAlerts(params)),
    refetchInterval,
  });
}

export function useWccAnalytics(params?: WorkstationControlCenterQueryParams) {
  return useQuery({
    queryKey: ['wcc', 'analytics', params],
    queryFn: async () => unwrap(await workstationControlCenterService.getAnalytics(params)),
  });
}
